import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utility
 * Returns: 'ios' | 'android' | 'web'
 */
export function getPlatform() {
  if (typeof window === 'undefined') {
    return 'web';
  }
  
  if (window.Capacitor) {
    const platform = Capacitor.getPlatform();
    if (platform === 'ios' || platform === 'android') {
      return platform;
    }
  }
  
  return 'web';
}

/**
 * Check if running on iOS
 */
export function isIOS() {
  return getPlatform() === 'ios';
}

/**
 * Check if running on Android
 */
export function isAndroid() {
  return getPlatform() === 'android';
}

/**
 * Check if running on native (iOS or Android)
 */
export function isNative() {
  const platform = getPlatform();
  return platform === 'ios' || platform === 'android';
}

/**
 * Check if running on web
 */
export function isWeb() {
  return getPlatform() === 'web';
}

/**
 * Check if running on mobile (iOS or Android)
 */
export function isMobile() {
  return isNative();
}
